<!-- 用户功能 - 注册弹窗 -->


<template>
  <transition name="fade">
    <div id="register-box">
      <div id="login" class="bgshade-box"></div>
      <div class="con-box">
        <!-- Register Information -->
        <div class="form-box">
          <p class="title-row">
            <span class="login-tit">注册</span>
            <span class="login-close" @click="closePopupR"></span>
          </p>
          <div class="regTab">
            <div class="regBtn" @click="changeRegisterWay">
              <span ref="mobileReg" :class="{ active: moibleIsActive }"
                >手机注册</span
              >
              <span ref="emailReg" :class="{ active: emailIsActive }"
                >邮箱注册</span
              >
            </div>
          </div>
          <p class="info-row tips tipsTop" v-if="userTips.registerResTips">
            {{ userTips.registerResTips }}
          </p>
          <!-- 手机号注册 -->
          <div v-if="moibleIsActive">
            <p class="info-row">
              <!-- start -->
              <!-- 解决谷歌浏览器选择保存密码后自动填充-->
              <input type="text" class="input-text" style="display: none" />
              <!-- ie9下模拟placeholder -->
              <label
                for="registerUserIdM"
                v-if="placeholder.registerUserIdM"
                class="simulate-placeholder"
                @click="ie9hideInputIdM"
                >手机号</label
              >
              <!-- end -->
              <input
                type="text"
                class="input-text"
                @blur="checkUser"
                ref="userIDMobile"
                placeholder="手机号"
                id="registerUserIdM"
                key="mobile-input"
                autocomplete="off"
                @focus="ie9hideInputIdM"
              />
            </p>
            <p class="info-row tips" v-if="userTips.userIdTips">
              {{ userTips.userIdTips }}
            </p>
            <p class="info-row tips" v-if="userTips.goLoginTips">
              用户名已经存在
            </p>
            <!-- <p class="info-row tips" v-if="userTips.goLoginTips">账号已注册，请直接<b class="goLogin" @click="goLogin">登录</b></p> -->
            <p class="pwd-row info-row">
              <!-- start -->
              <!--解决谷歌浏览器选择保存密码后自动填充-->
              <input type="password" class="input-text" style="display: none" />
              <!-- ie9下模拟placeholder -->
              <label
                for="registerUserPwdM"
                v-if="placeholder.registerUserPwdM"
                class="simulate-placeholder"
                @click="ie9hideInputPwdM"
                >设置密码&nbsp;&nbsp;&nbsp;6~18位数字、字母</label
              >
              <!-- end -->
              <input
                type="password"
                class="input-text"
                @blur="checkPwd"
                ref="userPwdMobile"
                id="registerUserPwdM"
                placeholder="设置密码   6~18位数字、字母"
                autocomplete="off"
                key="pwdM"
                @focus="ie9hideInputPwdM"
              />
              <img
                src="../../assets/user/showpwd.png"
                v-if="showpwd"
                key="ms1"
                ref="showpwdM"
                @click="pwdIsShow"
              />
              <img
                src="../../assets/user/hidepwd.png"
                v-if="hidepwd"
                key="mh2"
                ref="showpwdM"
                @click="pwdIsShow"
              />
            </p>
            <p class="info-row tips" v-if="userTips.userPwdTipsMobile">
              {{ userTips.userPwdTipsMobile }}
            </p>
            <p class="security-row" style="position: relative">
              <!-- ie9下模拟placeholder -->
              <label
                for="registerUserSecM"
                v-if="placeholder.registerUserSecM"
                class="simulate-placeholder"
                @click="ie9hideInputSecM"
                >验证码</label
              >
              <input
                type="text"
                class="input-text input-code"
                @blur="checkSecCode"
                ref="secCode"
                id="registerUserSecM"
                name="vcode"
                placeholder="验证码"
                @focus="ie9hideInputSecM"
              />
              <input
                type="button"
                class="input-text input-codebtn"
                @click="sendCode"
                ref="sendCode"
                value="发送验证码"
                :class="{ isSend: isSend, isPhone: isPhone }"
              />
            </p>
            <p class="info-row tips" v-if="userTips.userSecTips1">
              验证码不正确
            </p>
            <p class="info-row tips" v-if="userTips.userSecTips2">
              请填写验证码
            </p>
          </div>
          <!-- 邮箱注册 -->
          <div v-if="emailIsActive">
            <p class="info-row">
              <!-- start -->
              <!--解决谷歌浏览器选择保存密码后自动填充-->
              <input type="text" class="input-text" style="display: none" />
              <!-- ie9下模拟placeholder -->
              <label
                for="registerUserIdE"
                v-if="placeholder.registerUserIdE"
                class="simulate-placeholder"
                @click="ie9hideInputIdE"
                >邮箱</label
              >
              <!-- end -->
              <input
                type="text"
                class="input-text"
                @blur="checkUser"
                ref="userIDEmail"
                placeholder="邮箱"
                value=""
                id="registerUserIdE"
                key="email-input"
                autocomplete="off"
                @focus="ie9hideInputIdE"
              />
            </p>
            <p class="info-row tips" v-if="userTips.userIdTipsEmail">
              {{ userTips.userIdTipsEmail }}
            </p>
            <p class="pwd-row info-row">
              <!-- start -->
              <!-- 解决谷歌浏览器选择保存密码后自动填充 -->
              <input type="password" class="input-text" style="display: none" />
              <!-- ie9下模拟placeholder -->
              <label
                for="registerUserPwdE"
                v-if="placeholder.registerUserPwdE"
                class="simulate-placeholder"
                @click="ie9hideInputPwdE"
                >设置密码&nbsp;&nbsp;&nbsp;6~18位数字、字母</label
              >
              <!-- end -->
              <input
                type="password"
                class="input-text"
                @blur="checkPwd"
                ref="userPwdEmail"
                autocomplete="off"
                id="registerUserPwdE"
                placeholder="设置密码   6~18位数字、字母"
                value=""
                key="pwdE"
                @focus="ie9hideInputPwdE"
              />
              <img
                src="../../assets/user/showpwd.png"
                v-if="showpwd"
                key="es1"
                ref="showpwdE"
                @click="pwdIsShow"
              />
              <img
                src="../../assets/user/hidepwd.png"
                v-if="hidepwd"
                key="eh2"
                ref="showpwdE"
                @click="pwdIsShow"
              />
            </p>
            <p class="info-row tips" v-if="userTips.userPwdTipsEmail">
              {{ userTips.userPwdTipsEmail }}
            </p>
          </div>
          <!-- 同意协议与否 -->
          <p class="agreement-row">
            <label class="label-agree" @click="agreeStatue = !agreeStatue">
              <!-- <transition name="slide-fade"> -->
              <img
                src="../../assets/images/common/selected_icon.png"
                v-if="agreeStatue"
              />
              <!-- </transition> -->
            </label>
            <span
              >同意<a
                style="color: #b11828"
                href="javascript:;"
                @click="getUserAgreement"
                >《用户协议》</a
              ></span
            >
          </p>
          <p class="info-row tips" v-if="userTips.agreementTips">
            {{ userTips.agreementTips }}
          </p>
          <p class="submit-row">
            <button @click="userRegister" :disabled="disabled">立即注册</button>
          </p>
          <p class="no-userID">
            <a href="javascript:;" @click="goLogin">使用IP360账号登录</a>
          </p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
//    import axios from 'axios';

//删除cookie
let delCookie = (name) => {
  setCookie(name, 1, -1);
};

//设置cookie
let setCookie = (name, value, day) => {
  let oDate = new Date();
  oDate.setDate(oDate.getDate() + day);
  document.cookie =
    name + "=" + JSON.stringify(value) + ";expires=" + oDate + ';path="/"';
};

//获取cookie
let getCookie = (name) => {
  let oArr = document.cookie.split(";");
  for (var i = 0; i < oArr.length; i++) {
    let arrName = oArr[i].split("=");
    if (arrName[0] == name) {
      return arrName[1];
    }
  }
  return "";
};

export default {
  name: "login",
  data() {
    return {
      userVal: {
        userIdVal: "",
        userPwdVal: "",
      },
      checkRes: {
        userIDCheckRes: false,
        userPwdCheckRes: false,
      },
      moibleIsActive: true,
      emailIsActive: false,
      agreeStatue: true,
      hidepwd: true,
      showpwd: false,
      secCode: false,
      secVal: "",
      isSend: true,
      isPhone: true,
      userTips: {
        userIdTips: "",
        goLoginTips: false,
        userPwdTipsMobile: "",
        userSecTips1: false, //不合法
        userSecTips2: false, //为空
        agreementTips: "",
        userIdTipsEmail: "",
        userPwdTipsEmail: "",
        registerResTips: "",
      },
      INPUTRULES: {
        email:
          /^([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/,
        mobile:
          /^(((13[0-9]{1})|(15[0-9]{1})|(17[0-9]{1})|(18[0-9]{1})|(14[0-9]{1}))+\d{8})$/,
        password: /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,18}$/,
        seccode: /^[0-9]{6}$/,
      },
      placeholder: {
        //手机注册模拟placeholder
        registerUserIdM: false,
        registerUserPwdM: false,
        registerUserSecM: false,
        //邮箱注册模拟placeholder
        registerUserIdE: false,
        registerUserPwdE: false,
      },
      disabled: false,
      //公钥
      pubKey: "",
    };
  },
  mounted() {
    if (!this.$isPlaceholder()) {
      for (let i in this.placeholder) {
        this.placeholder[i] = true;
      }
    }
    this.getEncryptPubKey();
  },
  methods: {
    //获取公钥
    getEncryptPubKey() {
      this.$axios
        .request({
          url: "/webapi/user/getEncryptPubKey",
          method: "GET",
          params: {},
        })
        .then((res) => {
          if (res.data.code == 200) {
            this.pubKey = res.data.datas.encryptPubKey;
          }
        });
    },
    /**
     * 通过公钥进行加密
     * data:要加密的数据
     */
    setEncrypt(data) {
      const jsRsa = new this.$jsEncrypt();
      //设置公钥
      jsRsa.setPublicKey(this.pubKey);
      //使用加密对象给数据加密
      let RsaData = jsRsa.encrypt(data);
      return RsaData;
    },
    //关闭注册窗口
    closePopupR() {
      this.$store.commit("hidePopWindow", "registerWin");
    },
    //发送验证码
    sendCode(e) {
      //用户名可以注册的情况下
      if (this.checkRes.userIDCheckRes && this.checkRes.userPwdCheckRes) {
        this.$axios
          .get("/webapi/user/sendPhoneVerifyCodeR", {
            params: {
              account: this.userVal.userIdVal,
              type: 1,
            },
          })
          .then((response) => {
            let res = response.data;
            //请求成功后倒计时
            if (res.code == 200) {
              this.isSend = false;
              e.target.disabled = true;
              let time = 60;
              e.target.value = time + "秒后重新获取";
              let timer = setInterval(() => {
                e.target.value = time + "秒后重新获取";
                time--;
                if (time == -2) {
                  clearInterval(timer);
                  e.target.value = "发送验证码";
                  e.target.disabled = false;
                  this.isSend = true;
                }
              }, 1000);
            } else if (res.code == 1001) {
              this.userTips.registerResTips = response.data.message;
            }
          });
      }
    },
    //检验验证码
    checkSecCode() {
      this.secVal = this.$refs.secCode.value;
      if (this.secVal != "") {
        this.userTips.userSecTips2 = false;
        if (this.INPUTRULES.seccode.test(this.secVal)) {
          this.userTips.userSecTips1 = false;
          this.secCode = true;
        } else {
          this.secCode = false;
          this.userTips.userSecTips1 = true;
        }
      } else {
        if (!this.$isPlaceholder()) {
          this.placeholder.registerUserSecM = true;
        }
      }
    },
    //手机注册或者邮箱注册选项卡
    changeRegisterWay(e) {
      for (let i in this.userTips) {
        this.userTips[i] = "";
      }
      this.hidepwd = true;
      this.checkRes.userIDCheckRes = false;
      this.checkRes.userPwdCheckRes = false;
      this.userTips.registerResTips = "";
      if (!this.$isPlaceholder()) {
        for (let i in this.placeholder) {
          this.placeholder[i] = true;
        }
      }
      if (e.target.innerHTML == "邮箱注册") {
        this.moibleIsActive = false;
        this.emailIsActive = true;
        this.changeH = true;
        this.isPhone = true;
      } else if (e.target.innerHTML == "手机注册") {
        this.moibleIsActive = true;
        this.emailIsActive = false;
        this.changeH = false;
        this.isPhone = true;
      }
    },
    //检验用户名
    checkUser() {
      this.isPhone = true;
      if (this.moibleIsActive) {
        //检测手机号注册
        this.userVal.userIdVal = this.$refs.userIDMobile.value;
        if (this.userVal.userIdVal != "") {
          if (this.INPUTRULES.mobile.test(this.userVal.userIdVal)) {
            this.userTips.userIdTips = "";
            this.userTips.goLoginTips = false;
            //验证是否已注册
            this.$axios
              .get("/webapi/user/checkAccount", {
                params: {
                  account: this.userVal.userIdVal,
                },
              })
              .then((response) => {
                let res = response.data;
                if (res.code == 3004) {
                  this.checkRes.userIDCheckRes = true;
                  if (
                    this.checkRes.userIDCheckRes &&
                    this.checkRes.userPwdCheckRes
                  ) {
                    this.isPhone = false;
                  } else {
                    this.isPhone = true;
                  }
                } else if (res.code == 3002) {
                  this.checkRes.userIDCheckRes = false;
                  this.userTips.goLoginTips = true;
                }
              });
          } else {
            this.userTips.goLoginTips = false;
            this.userTips.userIdTips = "手机号格式有误";
            this.checkRes.userIDCheckRes = false;
          }
        } else {
          if (!this.$isPlaceholder()) {
            this.placeholder.registerUserIdM = true;
          }
        }
      } else if (this.emailIsActive) {
        //检测邮箱注册
        this.userVal.userIdVal = this.$refs.userIDEmail.value;
        if (this.userVal.userIdVal != "") {
          if (this.INPUTRULES.email.test(this.userVal.userIdVal)) {
            this.userTips.userIdTipsEmail = "";
            this.$axios
              .get("/webapi/user/checkAccount", {
                params: {
                  account: this.userVal.userIdVal,
                },
              })
              .then((response) => {
                let res = response.data;
                if (res.code == 3004) {
                  this.checkRes.userIDCheckRes = true;
                } else {
                  this.checkRes.userIDCheckRes = false;
                  this.userTips.userIdTipsEmail = res.message;
                }
              });
          } else {
            this.userTips.userIdTipsEmail = "邮箱格式有误";
            this.checkRes.userIDCheckRes = false;
          }
        } else {
          if (!this.$isPlaceholder()) {
            this.placeholder.registerUserIdE = true;
          }
        }
      }
    },
    //检验密码
    checkPwd() {
      if (this.moibleIsActive) {
        //手机注册
        this.userVal.userPwdVal = this.$refs.userPwdMobile.value;
      } else if (this.emailIsActive) {
        //邮箱注册
        this.userVal.userPwdVal = this.$refs.userPwdEmail.value;
      }
      this.isPhone = true;
      if (this.userVal.userPwdVal) {
        if (this.INPUTRULES.password.test(this.userVal.userPwdVal)) {
          this.checkRes.userPwdCheckRes = true;
          this.userTips.userPwdTipsMobile = "";
          this.userTips.userPwdTipsEmail = "";
          if (this.checkRes.userIDCheckRes && this.checkRes.userPwdCheckRes) {
            this.isPhone = false;
          } else {
            this.isPhone = true;
          }
        } else {
          this.checkRes.userPwdCheckRes = false;
          if (this.moibleIsActive) {
            this.userTips.userPwdTipsMobile = "密码格式有误";
          } else {
            this.userTips.userPwdTipsEmail = "密码格式有误";
          }
        }
      } else {
        if (!this.$isPlaceholder()) {
          if (this.moibleIsActive) {
            //手机注册
            this.placeholder.registerUserPwdM = true;
          } else if (this.emailIsActive) {
            //邮箱注册
            this.placeholder.registerUserPwdE = true;
          }
        }
      }
    },
    //注册事件
    userRegister() {
      if (this.agreeStatue) {
        this.userTips.agreementTips = "";
      } else {
        this.userTips.agreementTips = "需同意用户协议";
      }
      //判断综合检测结果
      let res =
        this.checkRes.userIDCheckRes &&
        this.checkRes.userPwdCheckRes &&
        this.agreeStatue;
      if (this.moibleIsActive) {
        res = res && this.secCode;
        //对应处理
        if (res) {
          this.disabled = true;
          this.$axios
            .request({
              url: "/webapi/user/saveUserInfoV2",
              method: "POST",
              data: {
                encryptAccount: this.setEncrypt(this.userVal.userIdVal),
                encryptPassword: this.setEncrypt(
                  this.$md5(this.userVal.userPwdVal)
                ),
                vcode: this.secVal,
              },
            })
            .then((response) => {
              this.disabled = false;
              // console.log("注册信息:", response);
              if (response.data.code == 200) {
                this.userTips.registerResTips = "注册成功";
                this.$store.commit("hidePopWindow", "registerWin");
                setCookie("IP360", this.userVal, 7);
                //直接登录进去
                let user = response.data.datas.loginUser;
                user.timestamp = Date.now();
                user.token = response.data.datas.token;
                let Truthso = {
                  user: user,
                };
                localStorage.setItem("IP360", JSON.stringify(Truthso));
                // console.log("test:", response.data.datas.loginUser);
                this.$store.commit("login", response.data.datas.loginUser);
                this.$emit("loggedIn", response.data.datas.loginUser);
                this.$store.dispatch("showMsgModal", {
                  autoClose: true,
                  info: "注册成功",
                });

                if (this.$store.state.redirect) {
                  this.$router.push(this.$store.state.redirect);
                  this.$store.state.redirect = "";
                }
                this.redirect = "";
              } else {
                this.userTips.registerResTips = response.data.message;
              }
            });
        }
        if (this.userVal.userIdVal == "") {
          this.userTips.userIdTips = "请填写用户名";
        }
        if (this.userVal.userPwdVal == "") {
          this.userTips.userPwdTipsMobile = "请填写密码";
        }
        if (this.secVal == "") {
          this.userTips.userSecTips1 = false;
          this.userTips.userSecTips2 = true;
        }
      } else if (this.emailIsActive) {
        if (res) {
          //                    setCookie('IP360',this.userVal,7);
          this.disabled = true;
          this.$axios
            .request({
              url: "/webapi/user/registerSendEmailV2",
              method: "GET",
              params: {
                encryptAccount: this.setEncrypt(this.userVal.userIdVal),
                encryptPassword: this.setEncrypt(
                  this.$md5(this.userVal.userPwdVal)
                ),
              },
            })
            .then((response) => {
              this.disabled = false;
              let res = response.data;
              if (response.data.code == 200) {
                this.userTips.registerResTips =
                  "激活邮件已发送，请登录您的邮箱：" +
                  this.userVal.userIdVal +
                  "查收";
              } else {
                this.userTips.registerResTips = res.message;
              }
            });
        }
        if (this.userVal.userIdVal == "") {
          this.userTips.userIdTipsEmail = "请填写用户名";
        }
        if (this.userVal.userPwdVal == "") {
          this.userTips.userPwdTipsEmail = "请填写密码";
        }
      }
    },
    //去登陆
    goLogin() {
      this.$store.commit("hidePopWindow", "registerWin");
      this.$store.commit("showPopWindow", "loginWin");
    },
    //密码显示与否
    pwdIsShow() {
      if (this.moibleIsActive) {
        if (this.$refs.userPwdMobile.type == "text") {
          this.$refs.userPwdMobile.type = "password";
          this.hidepwd = true;
          this.showpwd = false;
        } else {
          this.$refs.userPwdMobile.type = "text";
          this.hidepwd = false;
          this.showpwd = true;
        }
      } else if (this.emailIsActive) {
        if (this.$refs.userPwdEmail.type == "text") {
          this.$refs.userPwdEmail.type = "password";
          this.hidepwd = true;
          this.showpwd = false;
        } else {
          this.$refs.userPwdEmail.type = "text";
          this.hidepwd = false;
          this.showpwd = true;
        }
      }
    },
    //用户协议
    getUserAgreement() {
      this.$store.commit("showUserAgree", true);
    },
    //模拟palceholder(ie9)
    ie9hideInputIdM() {
      this.placeholder.registerUserIdM = false;
    },
    ie9hideInputPwdM() {
      this.placeholder.registerUserPwdM = false;
    },
    ie9hideInputSecM() {
      this.placeholder.registerUserSecM = false;
    },
    ie9hideInputIdE() {
      this.placeholder.registerUserIdE = false;
    },
    ie9hideInputPwdE() {
      this.placeholder.registerUserPwdE = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*  reset style */
p {
  margin: 0;
}
a {
  text-decoration: none;
  color: #000;
}
input,
button {
  outline: 0;
}
/* basis style */
#register-box,
.bgshade-box {
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}
/* basis style */
#register-box {
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 16px;
  filter: alpha(opacity=50);
}
.con-box {
  width: 408px;
  background: #fff;
  border-radius: 5px;
  /* border: 1px solid #Eb828c; */
  position: absolute;
  top: 16%;
  left: 50%;
  transform: translate(-204px, 0);
}
@media (min-height: 670px) {
  .con-box {
    top: 19%;
  }
}
/* form style */
.form-box {
  width: 364px;
  margin: 0 auto;
}
.form-box .title-row {
  height: 38px;
  margin-top: 19px;
  color: #b11828;
  font-weight: 700;
  line-height: 24px;
}
.form-box .login-tit {
  float: left;
}
.form-box .login-close {
  float: right;
  cursor: pointer;
  width: 22px;
  height: 22px;
  background: url("../../assets/images/drawer/shut_nor_icon.png") no-repeat;
  background-size: 100% 100%;
}
.form-box .login-close:hover {
  background: url("../../assets/images/drawer/shut_hov_pre_icon.png") no-repeat;
  background-size: 100% 100%;
}
.form-box .regTab {
  height: 44px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 14px;
}
.form-box .regTab span {
  float: left;
  width: 50%;
  height: 43px;
  line-height: 43px;
  cursor: pointer;
  text-align: center;
  user-select: none;
}
.form-box .regTab span.active {
  border-bottom: 2px solid #b11828;
  color: #b11828;
}
.form-box .info-row {
  margin: 11px 0;
  position: relative;
}
.form-box p.tips {
  font-size: 14px;
  color: #b11828;
  padding-left: 20px;
}
.form-box p.tipsTop {
  padding-right: 20px;
  text-align: center;
}
.form-box .pwd-row {
  position: relative;
  margin-top: 11px;
}
.form-box .pwd-row img {
  position: absolute;
  right: 10px;
  top: 18px;
  cursor: pointer;
}
.form-box .input-text {
  padding-left: 20px;
  box-sizing: border-box;
  width: 100%;
  height: 50px;
  border-radius: 5px;
  border: 0;
  border: 1px solid #c3c3c3;
  outline: 0;
  box-shadow: 0 0 0px 1000px white inset;
}
.form-box .input-code {
  width: 234px;
}
.form-box .input-codebtn {
  padding: 0;
  width: 120px;
  background: #fff;
  float: right;
  text-align: center;
  cursor: pointer;
}
.form-box input.input-agree {
  display: none;
}
.form-box .label-agree {
  display: block;
  width: 14px;
  height: 14px;
  border: 1px solid #ccc;
  margin-right: 9px;
  margin-top: 2px;
  border-radius: 2px;
}
.form-box .label-agree img {
  width: 14px !important;
  height: 14px !important;
}
.form-box .agreement-row {
  height: 40px;
  padding-top: 15px;
  box-sizing: border-box;
  /*display: flex;*/
  /*align-items: center;*/
  font-size: 14px;
}
.form-box .agreement-row span {
  float: left;
}
.form-box .agreement-row span a {
  color: rgba(65, 155, 249, 1);
}
.form-box .agreement-row label {
  float: left;
  position: relative;
}
.form-box .agreement-row label img {
  position: absolute;
  left: -1px;
  top: -1px;
  width: 100%;
  height: 100%;
}
.form-box .select {
  overflow: hidden;
}
.form-box .submit-row button {
  display: block;
  width: 100%;
  height: 50px;
  line-height: 50px;
  border-radius: 5px;
  text-align: center;
  background: #b11828;
  border: 0;
  font-size: 16px;
  color: #fff;
  margin: 11px 0;
  cursor: pointer;
  user-select: none;
}
.form-box .submit-row button:hover {
  background: #9c0f1f;
}
.form-box .no-userID {
  text-align: center;
  font-size: 14px;
  color: #747474;
  letter-spacing: 1px;
  margin: 35px 0 25px;
  margin-top: 18px;
}
.form-box .no-userID a {
  color: #b11828;
  border-bottom: 1px solid #b11828;
}
.isSend {
  /*background-color: #b11828!important;*/
  box-shadow: 0 0 0px 1000px #b11828 inset !important;
  color: #fff;
  border: 0;
}
.isPhone {
  box-shadow: 0 0 0px 1000px #fff inset !important;
  color: #a19f9f;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-active {
  transform: translateX(10px);
  opacity: 0;
}
.goLogin {
  border-bottom: 1px solid #b11828;
  cursor: pointer;
  font-size: 14px;
  /*font-weight: 600;*/
  font-weight: normal;
}
</style>



// WEBPACK FOOTER //
// Register.vue?011d5aba